export const homePromos = [
  {
    id: 'other-pen-names',
    enabled: true, // flip to false when want to take out
    image: {
      key: 'mumslife', 
      alt: "Jane Corry's republished romance titles",
    },
    intro: {
      textBeforeLink:
        "Before my Jane Corry books, I wrote romance as Sophie King and Janey Fraser. Now they're being re-published in digital and audio format by",
      linkText: 'Embla Books.',
      linkUrl: 'https://www.instagram.com/emblabooks/',
      textAfterLink:
        'So if you fancy some warm-hearted romance about family life, find my books here:',
    },
    accordions: [
      {
        id: 'janey-fraser',
        title: 'Janey Fraser',
        links: [
          {label: 'Happy Families', url: 'https://geni.us/HPRp4'},
          {label: 'The Playgroup', url: 'https://geni.us/ZXcbBX2'},
          {label: 'After the Honeymoon', url: 'https://geni.us/k1apP'},
        ],
      },
      {
        id: 'sophie-king',
        title: 'Sophie King',
        links: [
          {label: 'It’s a Mum’s Life', url: 'https://geni.us/7CTKw7j'},
          {label: 'The School Run', url: 'https://geni.us/xGvh7m'},
          {label: 'The Supper Club', url: 'https://geni.us/zd3qvhF'},
          {label: 'The Wedding Party', url: 'https://geni.us/b6gPJp9'},
          {label: 'The House Share', url: 'https://geni.us/YYu5CDZ'},
        ],
      },
    ],
  },

  // add new promos like this:
  // { id: "new-award", enabled: false, ... }
];
